import { gql } from '@apollo/client';
const GET_ORDERS_COUNT = gql `
  query GetOrdersCount($statuses: [String], $seasonId: ID) {
    me {
      id
      ordersCount(statuses: $statuses, seasonId: $seasonId)
    }
  }
`;
export default GET_ORDERS_COUNT;
